export default "__VITE_ASSET__c0bfb19c__"